import React from 'react'
import PropTypes from 'prop-types'
import { StyledSimpleSelect } from '../style'

const SimpleSelect = ({
  options,
  widthPercentage,
  placeholder,
  onChange,
  minWidth,
  isSearchable = false,
  isValid = true,
  closeMenuOnSelect,
  components,
  value = null,
  dropdownClassName,
  absolute,
}) => (
  <StyledSimpleSelect
    absolute={absolute}
    options={options}
    placeholder={placeholder}
    widthPercentage={widthPercentage}
    minWidth={minWidth}
    onChange={onChange}
    classNamePrefix="react-select"
    className={'react-select-container ' + dropdownClassName}
    isValid={isValid}
    isSearchable={isSearchable}
    closeMenuOnSelect={closeMenuOnSelect}
    components={components}
    value={value}
    cursor={isSearchable && 'text'}
    styles={{
      menu: provided => ({ ...provided, zIndex: 9999 }),
    }}
  />
)

SimpleSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  widthPercentage: PropTypes.number,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

export default SimpleSelect
